/**
 * @constructor
 * @extends {MadnesObject}
 * @param {string=} name
 * @returns {MadnesGraphics}
 */
import {
	madnes_add_graphics,
	madnes_graphics_begin_fill, madnes_graphics_clear,
	madnes_graphics_draw_circle,
	madnes_graphics_draw_rectangle,
	madnes_graphics_end_fill, madnes_graphics_line_to,
	madnes_graphics_move_to,
	madnes_graphics_set_line_style
} from "../../../framework/src/engine/madnes/madnes_draw";
import {madnes_set_alpha} from "../../../framework/src/engine/madnes/madnes_object";
import {MadnesObject} from "./MadnesObject";

export function MadnesGraphics(name) {
	MadnesObject.call(this, name);
};

MadnesGraphics.prototype = Object.create(MadnesObject.prototype);
MadnesGraphics.prototype.constructor = MadnesGraphics;

/**
 * @param {number} x
 * @param {number} y
 * @returns {MadnesGraphics}
 */
MadnesGraphics.prototype.create = function(x, y) {
	madnes_add_graphics(this.name, x, y);
	return this;
};

/**
 * @param {number} lineWidth
 * @param {number} color
 * @param {number} alpha
 * @returns {MadnesGraphics}
 */
MadnesGraphics.prototype.setLineStyle = function(lineWidth, color, alpha) {
	madnes_graphics_set_line_style(this.name, lineWidth, color, alpha);
	return this;
};

/**
 * @param {number} color
 * @returns {MadnesGraphics}
 */
MadnesGraphics.prototype.beginFill = function(color) {
	madnes_graphics_begin_fill(this.name, color);
	return this;
};

MadnesGraphics.prototype.endFill = function() {
	madnes_graphics_end_fill(this.name);
};

MadnesGraphics.prototype.drawRectangle = function(x, y, width, height) {
	madnes_graphics_draw_rectangle(this.name, x, y, width, height);
};

/**
 * @param {number} x
 * @param {number} y
 * @param {number} diameter
 * @returns {MadnesGraphics}
 */
MadnesGraphics.prototype.drawCircle = function(x, y, diameter) {
	madnes_graphics_draw_circle(this.name, x, y, diameter);
	return this;
};

MadnesGraphics.prototype.moveTo = function(x, y) {
	madnes_graphics_move_to(this.name, x, y);
};

MadnesGraphics.prototype.lineTo = function(x, y) {
	madnes_graphics_line_to(this.name, x, y);
};

/**
 * @param {number} alpha
 * @returns {MadnesGraphics}
 */
MadnesGraphics.prototype.setAlpha = function(alpha) {
	madnes_set_alpha(this.name, alpha);
	return this;
};

MadnesGraphics.prototype.clear = function() {
	madnes_graphics_clear(this.name);
};